import { useParams } from "react-router";
import { useEffect, useState } from "react";
import EmailSequenceService from "../Services/EmailSequenceService";
import moment from 'moment';
import UtilsService from "../Services/UtilsService";
import { Tooltip } from 'react-tooltip';
const { convertHtmlToText } = UtilsService;

function SequenceEmailsLogs() {

    const { id: sequence_id } = useParams();

    const [emailLogs, setEmailLogs] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState([]);
    const [filterFrom, setFilterFrom] = useState('');
    const [filterTo, setFilterTo] = useState('');

    useEffect(() => {
        getEmailLogs();
    }, []);

    useEffect(() => {
        filterLogs();
    }, [emailLogs, filterFrom, filterTo]);

    async function getEmailLogs() {
        let logs = await EmailSequenceService.getEmailSequencesLogsBySequenceId(sequence_id);
        setEmailLogs(logs);
    }

    function filterLogs() {
        let filtered = emailLogs;

        if (filterFrom) {
            filtered = filtered.filter(log => 
                log.from && log.from.toLowerCase().includes(filterFrom.toLowerCase())
            );
        }

        if (filterTo) {
            filtered = filtered.filter(log => 
                log.to && log.to.toLowerCase().includes(filterTo.toLowerCase())
            );
        }

        setFilteredLogs(filtered);
    }

    function clearFilters() {
        setFilterFrom('');
        setFilterTo('');
    }

    function renderEmailLogs() {
        return filteredLogs.map((emailLog, i) => {

            return (
                <div key={`email-log-${i}`} className='email-sequence-item'>
                    <div className="fs-13 me-3">
                        <div><b>From:</b> {emailLog.from}</div>
                        <div><b>To:</b> {emailLog.to}</div>
                    </div>
                    <div className="fs-13">
                        <div className="mb-1"><b>Subject:</b> {emailLog.subject}</div>
                        <div><b>Body:</b> {convertHtmlToText(emailLog.body).substring(0, 300)}...</div>
                    </div>
                    <div
                        data-tooltip-id="sequence-logs"
                        style={{ minWidth: '120px' }}
                        data-tooltip-content={`${moment(emailLog.sent_at).fromNow()}`}
                        className="fs-13 ms-3">
                        <b>Sent at:</b> {moment(emailLog.created_at).format('MM/DD/YYYY hh:mm:ss a')}
                    </div>
                    <div
                        style={{ minWidth: '200px' }}
                        className="fs-13 ms-3">
                        <b>Result:</b> {emailLog.sent_result}
                    </div>
                </div>
            )
        })
    }

    return (
        <div>
            <div className="container">
                <div className="sequence-detail-container">
                    
                    {/* Filtros */}
                    <div className="row mb-4">
                    
                        <div className="col-md-4">
                            <div className="form-group">
                                <label htmlFor="filterTo" className="form-label">Filter by To:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="filterTo"
                                    value={filterTo}
                                    onChange={(e) => setFilterTo(e.target.value)}
                                    placeholder="Enter recipient email..."
                                />
                            </div>
                        </div>
                        <div className="col-md-4 d-flex align-items-end">
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={clearFilters}
                                disabled={!filterFrom && !filterTo}
                            >
                                Clear Filters
                            </button>
                        </div>
                    </div>

                    {/* Results information */}
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="alert alert-primary">
                                Showing {filteredLogs.length} of {emailLogs.length} email logs
                                {(filterFrom || filterTo) && (
                                    <span className="ms-2">
                                        (filtered by: {filterFrom && `from: "${filterFrom}"`}{filterFrom && filterTo && ' and '}{filterTo && `to: "${filterTo}"`})
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    {renderEmailLogs()}

                </div>
            </div>

            <Tooltip id="sequence-logs" />
        </div>
    )

}

export default SequenceEmailsLogs;